import { createContext, useContext, useMemo, useState } from "react";
import { fetchData } from "../../lib/dashboard/data";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";

const GlobalMarketTopPriceChangesContext = createContext();

const GlobalMarketTopPriceChangesProvider = ({ children }) => {
  const [symbolChecked, setSymbolChecked] = useState(true);

  const [searchParams] = useSearchParams();

  const topPriceChanges = useSWR(
    [`/global-market/top-price-change`, `${searchParams.toString()}`],
    ([url, params]) => fetchData(url, params),
    { dedupingInterval: 36000 }
  );

  const filteredData = useMemo(() => {
    return symbolChecked
      ? topPriceChanges.data?.filter((item) => item.symbol !== "")
      : topPriceChanges.data;
  }, [symbolChecked, topPriceChanges.data]);

  const tableData = {
    ...topPriceChanges,
    data: filteredData,
  };

  return (
    <GlobalMarketTopPriceChangesContext.Provider
      value={{ tableData, symbolChecked, setSymbolChecked }}
    >
      {children}
    </GlobalMarketTopPriceChangesContext.Provider>
  );
};

export default GlobalMarketTopPriceChangesProvider;

export const useGlobalMarketTopPriceChangesContext = () =>
  useContext(GlobalMarketTopPriceChangesContext);
